<app-dialog
    [(visible)]="visible"
    title="Edit thread title"
    [width]="'30rem'"
    [showCloseButton]="true"
    (closed)="handleHide()">

    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-1 w-full">
            <label for="title" class="text-md font-medium">Title</label>
            <app-input type="text" id="title" [(ngModel)]="threadTitleToEdit" />
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="Save" toolTip="Save" tooltipPosition="top" (clicked)="handleSave()"
                [enableThrottle]="true" variant="filled" [disabled]="isSaveDisabled" severity="primary" />
        </div>
    </ng-template>
</app-dialog>
